import { ObjectPageSubSectionMode } from "sap/uxap/library";
import BaseController from "../controller/BaseController";
import ObjectPageSubSection from "sap/uxap/ObjectPageSubSection";
import { Button$ClickEventParameters } from "sap/ui/webc/main/Button";
import JSONModel from "sap/ui/model/json/JSONModel";
import { KundeRemarks } from "../model/models";
import { EnvironmentService } from "../service/Environment.service";
import { ErrorHandler } from "../service/ErrorHandler.service";

/**
 * @namespace com.unitrade.crm.blocks
 */
export default class ContactsBlock extends BaseController {
  private _metaModel: JSONModel;
  onInit(): void {
    this._metaModel = new JSONModel({ busy: false });
    this.setModel(this._metaModel, "meta");
  }

  handlePress() {
    const parentBlock = (this as any).oParentBlock as ObjectPageSubSection;
    const sNewMode = parentBlock.getMode() === ObjectPageSubSectionMode.Collapsed ? ObjectPageSubSectionMode.Expanded : ObjectPageSubSectionMode.Collapsed;
    parentBlock.setMode(sNewMode);
  }

  visibleFormatter(remark: string) {
    return !!remark && !!remark.trim();
  }

  noNotesVisibleFormatter(remark1: string, remark2: string) {
    return !(this.visibleFormatter(remark1) || this.visibleFormatter(remark2));
  }

  async save(oEvent: Button$ClickEventParameters) {
    this._metaModel.setProperty("busy", true);
    try {
      const customerModel = this.getModel("Customer") as JSONModel;
      const kuid: number = customerModel.getProperty("/id");
      const kulfd: number = customerModel.getProperty("/lfd");
      const remark1: string = customerModel.getProperty("/anmerkung1");
      const remark2: string = customerModel.getProperty("/anmerkung2");
      const vid: number = customerModel.getProperty("/vid");

      const postModel = <KundeRemarks>{
        anmerkung1: remark1,
        anmerkung2: remark2,
        vid: vid,
      };

      const result: KundeRemarks = await $.post(`${EnvironmentService.getBaseUrl()}/kunde/${kuid}/${kulfd}/remarks`, JSON.stringify(postModel));
      customerModel.setProperty("/anmerkung1", result.anmerkung1);
      customerModel.setProperty("/anmerkung2", result.anmerkung2);
      customerModel.setProperty("/vid", result.vid);
      this.handlePress();
    } catch (ex: any) {
      ErrorHandler.handleError(ex);
    } finally {
      this._metaModel.setProperty("busy", false);
    }
  }
}
